import {message} from '@sail/intl';
import type {ConnectElementImportKeys} from '../../connect/ConnectJSInterface/ConnectElementList';

export type MessageKeys =
  | 'componentNotEnabled'
  | 'emptyNotificationsBanner'
  | 'notOnboarded'
  | 'notSupportedAccountOrPlatform'
  | 'mustUseHttpsInLivemode'
  | 'mustBeGatedIntoMobileSdkPreview';

export const messages = {
  componentNotEnabled: message<{
    connectElement: ConnectElementImportKeys;
  }>({
    id: 'connectEmbed.devNoticeBanner.componentNotEnabled',
    defaultMessage:
      'The {connectElement} component is not rendered as it was not enabled in the current account session. To enable, specify `enabled: true` for this component in the create account session request. In the Sample platform, you can do this by using the Enable/disable components button.',
    description:
      'Message that shows only in Login as/dev environment when the component is not enabled',
  }),
  emptyNotificationsBanner: message({
    id: 'connectEmbed.devNoticeBanner.emptyNotificationsBanner',
    defaultMessage:
      "Since this account doesn't have any currently due compliance or risk intervention tasks, the notifications banner component will not render.",
    description:
      'Message that shows only in Login as/dev environment when the notifications banner is empty',
  }),
  notOnboarded: message({
    id: 'connectEmbed.devNoticeBanner.notOnboarded',
    defaultMessage: 'Note: This account has not yet finished onboarding.',
    description:
      'Message that shows only in Login as/dev environment when viewing the Account onboarding component when the account has not finished onboarding.',
  }),
  notSupportedAccountOrPlatform: message<{
    connectElement: ConnectElementImportKeys;
  }>({
    id: 'connectEmbed.devNoticeBanner.notSupportedAccountOrPlatform',
    defaultMessage:
      'This account or platform does not support {connectElement}.',
    description:
      'Message that shows when the account or platform has not enabled the component.',
  }),
  mustUseHttpsInLivemode: message({
    id: 'connectEmbed.devNoticeBanner.mustUseHttpsInLivemode',
    defaultMessage:
      'Live integrations must use HTTPS. For more information: https://stripe.com/docs/security/guide#tls',
    description:
      'Message that shows to indicate you have to use https in livemode',
  }),
  mustBeGatedIntoMobileSdkPreview: message({
    id: 'connectEmbed.devNoticeBanner.mustBeGatedIntoMobileSdkPreview',
    defaultMessage:
      'You do not have access to the Connect Mobile Sdk Private Preview. To request access, please visit: https://docs.stripe.com/connect/get-started-connect-embedded-components?platform=ios#request-access',
    description:
      'Message shows when the platform is using the Mobile SDK without being gated in',
  }),
  title: message({
    id: 'connectEmbed.devNoticeBanner.title',
    defaultMessage: 'Stripe internal only',
    description: 'Title for the dev notice banner',
  }),
};
